const MIN_AGGREGATE_COUNT_FOR_VIEW_ALL_LINK = 5;

export function shouldShowViewAllFooter(showTermedStatus: boolean, totalAggregateCount: number | undefined): boolean {
  return showTermedStatus || totalAggregateCount > MIN_AGGREGATE_COUNT_FOR_VIEW_ALL_LINK;
}
